module.exports = __webpack_public_path__ + "img/12.70b97c69.png";